<as-split direction="horizontal" unit="pixel" [disabled]="true" [gutterSize]="18">
  <!-- <as-split-area [size]="250">
    <div class="sidebar">
      <h2 class="admin-header">Admin sections</h2>

      <div class="button-container">
        <ng-container *ngIf="isAdmin">

          <button routerLink="provider-list" mat-button>
            <mat-icon svgIcon="folder-wrench"></mat-icon>
            <span class="name">Provider list</span>
          </button>

          <button routerLink="issues-list" mat-button>
            <mat-icon svgIcon="folder-wrench"></mat-icon>
            <span class="name">Issues</span>
          </button>

        </ng-container>
      </div>

      <div class="spacer"></div>
    </div>
  </as-split-area> -->

  <as-split-area class="admin-route">
    <router-outlet></router-outlet>
  </as-split-area>
</as-split>
